import React, { useEffect, useState } from 'react';
import { Button, Divider, Switch, Tag, Tooltip, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { SelectionProcessesService } from '../../../../../src/core/services/selection_processes_service';
import { MettlSelectionModal } from '@rankmi/ats-app';
import styles from './AssessmentsMettlForm.module.scss';

const MAX_SELECTED_TESTS = 5;

const selectionProcessesService = new SelectionProcessesService();

const AssessmentsMettlForm = ({ form, processId, activated }) => {
  const [tests, setTests] = useState([]);
  const [stock, setStock] = useState(Infinity);
  const [isMettlActive, setIsMettlActive] = useState(true);
  const [showMettlTests, setShowMettlTests] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTests, setSelectedTests] = useState([]);
  const showWarning = !stock && isMettlActive;

  useEffect(() => {
    if (processId) {
      setIsLoading(true);
      selectionProcessesService.fetchListSelectedTests(
        processId,
        ({ tests, selected, stock, mettl_activation }) => {
          setIsMettlActive(mettl_activation);
          setSelectedTests(selected);
          setTests(tests);
          setStock(stock);
          setIsLoading(false);
        },
        (error) => {
          console.error(error.message);
          setIsLoading(false);
        }
      );
    }
  }, [processId]);

  const onSelectTests = (tests) => {
    setSelectedTests(tests.selectedItems);
    const payload = { tests: tests.selectedItems };
    selectionProcessesService.saveSelectedTests(
      processId,
      payload,
      () => {
        setShowMettlTests(false);
      },
      () => {
        setShowMettlTests(false);
      }
    );
  };
  return (
    <>
    <Spin spinning={isLoading}>
      {showWarning && (
        <div className={styles.alert}>
          <span className={styles.text}>
            <FontAwesomeIcon
              className="icon-warning"
              color="#FAAD14"
              icon={faTriangleExclamation}
            />
            <span className={styles.bold}>
              Has agotado tu plan de pruebas con SHL.
            </span>{' '}
            Si deseas solicitar más información contáctate con tu ejecutivo
            comercial.
          </span>
        </div>
      )}
      <div className={styles.wrapper}>
        <div className={styles.body}>
          <h3 className={styles.title}>Habilitar pruebas</h3>
          <p className={styles.description}>
            Elige el grupo de pruebas que deseas que se envíen a tus candidatos
            en este proceso (Kudert, SHL, Disc, Kostic y IC)
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="primary" onClick={() => setShowMettlTests(true)}>
            <FontAwesomeIcon color="#2684ff" icon={faGear} />
            Configurar
          </Button>
          {form.getFieldDecorator('test_activation')(
            <Switch
              defaultChecked={activated ? activated : false}
              unCheckedChildren="No"
              checkedChildren="Si"
            ></Switch>
          )}
        </div>
      </div>
      <MettlSelectionModal
        isMettlActive={isMettlActive}
        selectedTests={selectedTests}
        loading={isLoading}
        open={showMettlTests}
        listTests={tests}
        onOk={onSelectTests}
        onCancel={() => setShowMettlTests(false)}
      />
      {!!selectedTests.length && <Divider className={styles.divider} />}
      <div className={styles.tests}>
        {selectedTests.slice(0, MAX_SELECTED_TESTS).map((test) => (
          <Tag key={`${test.name}|${test.source}|${test.value}`}>
            {test.name}
            <span className={styles.provider}> - {test.source}</span>
          </Tag>
        ))}
        {selectedTests.length > MAX_SELECTED_TESTS && (
          <Tooltip
            title={selectedTests
              .slice(MAX_SELECTED_TESTS)
              .map((t) => t.name)
              .join('\n')}
          >
            <Tag className={styles.showMore}>
              + {selectedTests.length - MAX_SELECTED_TESTS}
            </Tag>
          </Tooltip>
        )}
      </div>
      </Spin>
    </>
  );
};

export default AssessmentsMettlForm;
